// src/pages/Convocations/ActorUnregistrationModal.jsx
import React, { useState, useEffect } from "react";
import { FaTimes, FaUserMinus } from "react-icons/fa";
import { toast } from "react-toastify";

import Button from "../../components/Button/Button";
import { getAllActorsByEventId, deleteActorFromEvent } from "./../../services/acteureventServices";
import formatDate from "./../../utils/formatDate";

const ActorUnregistrationModal = ({
  isOpen,
  onClose,
  eventId,
  eventTitle,
  eventStart,
  refreshList,
}) => {
  const [actors, setActors] = useState([]);

  useEffect(() => {
    if (isOpen && eventId) {
      fetchActors();
    }
  }, [isOpen, eventId]);

  const fetchActors = async () => {
    try {
      const data = await getAllActorsByEventId(eventId);
      const sortedActors = (data?.Acteur || []).sort((a, b) => {
        const nameA = `${a.nom} ${a.prenom}`.toLowerCase();
        const nameB = `${b.nom} ${b.prenom}`.toLowerCase();
        return nameA.localeCompare(nameB);
      });
      setActors(sortedActors);
    } catch (error) {
      console.error("Erreur lors du chargement des acteurs", error);
      toast.error("Erreur lors du chargement des acteurs.");
    }
  };

  const handleUnregister = async (acteurId, label) => {
    if (
      !window.confirm(
        `Confirmez-vous la désinscription de ${label} sur cet événement ?`
      )
    ) {
      return;
    }

    try {
      await deleteActorFromEvent(acteurId, eventId);
      toast.success("Acteur désinscrit avec succès.");
      fetchActors();
      refreshList();
    } catch (error) {
      console.error("Erreur lors de la désinscription de l'acteur", error);
      toast.error("Erreur lors de la désinscription de l'acteur.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="modal-box bg-white dark:bg-slate-400 p-4 rounded-lg shadow-lg max-w-lg w-full">
        <h3 className="text-xl font-bold uppercase p-3 mb-3 text-center text-white bg-primary rounded-md shadow">
          Désinscrire un Acteur
        </h3>

        {/* Rappel événement */}
        <div className="mb-4 rounded-xl bg-slate-50 dark:bg-slate-800/80 p-3 text-xs sm:text-sm text-slate-700 dark:text-slate-100 ring-1 ring-slate-200 dark:ring-slate-700">
          <div className="font-semibold">
            {eventTitle || "Événement non trouvé"}
          </div>
          {eventStart && (
            <div className="mt-0.5">
              Date :{" "}
              <span className="font-medium">
                {formatDate(eventStart)}
              </span>
            </div>
          )}
          <div className="mt-1 text-[11px] italic text-slate-500 dark:text-slate-300">
            Cliquez sur “Désinscrire” pour retirer un acteur de la
            convocation.
          </div>
        </div>

        <div className="mb-4 max-h-72 overflow-y-auto pr-1">
          {actors.length > 0 ? (
            actors.map((actor) => {
              const label = `${actor.nom.toUpperCase()} ${
                actor.prenom
              }${actor.ActeurEvent?.poste ? ` - ${actor.ActeurEvent.poste}` : ""}`;
              return (
                <div
                  key={actor.ActeurEvent.acteur_id}
                  className="flex justify-between items-center mb-2 p-2 rounded-lg bg-slate-50 dark:bg-slate-200/80 text-sm"
                >
                  <div className="flex flex-col">
                    <span className="font-semibold text-slate-900">
                      {actor.nom.toUpperCase()} {actor.prenom}
                    </span>
                    <span className="text-[11px] text-slate-600">
                      Poste :{" "}
                      <span className="font-medium">
                        {actor.ActeurEvent?.poste || "Non renseigné"}
                      </span>
                    </span>
                  </div>
                  <Button
                    onClick={() =>
                      handleUnregister(actor.ActeurEvent.acteur_id, label)
                    }
                    className="btn-error flex items-center gap-2 btn-sm"
                    text="Désinscrire"
                    icon={FaUserMinus}
                  />
                </div>
              );
            })
          ) : (
            <p className="text-sm text-slate-600 dark:text-slate-100">
              Aucun acteur n’est actuellement inscrit sur cet événement.
            </p>
          )}
        </div>

        <div className="flex justify-center mt-2">
          <Button
            onClick={onClose}
            className="btn-ghost flex items-center gap-2"
            text="Fermer"
            icon={FaTimes}
          />
        </div>
      </div>
    </div>
  );
};

export default ActorUnregistrationModal;
